<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Consulta clientes - {{this.titulocliente}}
    </h3>
    <button (keydown.tab)="onNexFocus('nuevo')" type="button" class="close" aria-label="Close" (click)="cerrar()"
        tabindex="205">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-lg-12">

            <div class="card">
                <div class="card-body">
                    <div [hidden]="vista !== 1">
                        <ngb-tabset>
                            <ngb-tab title="General">

                                <ng-template ngbTabContent>
                                    <div class="card-body">

                                        <hr>
                                        <div class="row">
                                            <div class="col-md-12">

                                                <div class="form-group row" style="margin-bottom: 0px;">

                                                    <label
                                                        class="col-md-2 text-left control-label col-form-label">Interlocutor
                                                        comercial</label>


                                                    <div class="col-sm-2">
                                                        <input type="text" class="form-control tsiInput"
                                                            name="desInterlocutor" [(ngModel)]="objCliente.codcli"
                                                            [disabled]="disabledInterlocutor" #selectTipoInventario
                                                            tabindex="5" data-toggle="tooltip" data-placement="top"
                                                            title="MÁXIMO DE 20 CARACTERES"
                                                            data-original-title="MÁXIMO DE 20 CARACTERES"
                                                            (keydown.enter)="onKeyEnterCodInterlocutor($event)"
                                                            #interlocutor>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <input type="text" class="custom-select"
                                                            class="form-control tsiInput select_border"
                                                            name="codInterlocutor" [(ngModel)]="objCliente.razonc"
                                                            style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                            [disabled]="disabledInterlocutor" tabindex="6" #razon
                                                            (keydown.enter)="onKeyEnterInterlocutor($event)">
                                                    </div>


                                                    <div class="input-group-btn">
                                                        <button *ngIf="buscarLimpiarBoton == 'buscar' "
                                                            class="btn btn-primary btn-sm boton m-b-5"
                                                            (click)="openModalInterlocutor()" type="button"
                                                            tabindex="7"><i class="fa fa-search"></i></button>
                                                        <button [disabled]="buscar"
                                                            *ngIf="buscarLimpiarBoton == 'borrar'"
                                                            class="btn btn-primary btn-sm boton m-b-5"
                                                            (click)="borrarDatosInterlocutor()" type="button"
                                                            tabindex="7"><i class="fas fa-times"></i></button>
                                                    </div>
                                                </div>

                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Tipo de
                                                        persona:
                                                    </label>
                                                    <div class="col-sm-2">
                                                        <select disabled
                                                            style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                            class="custom-select"
                                                            class="form-control tsiInput select_border"
                                                            (change)="onSelectTipoPersonaIns($event.target.value)"
                                                            id="codtpe" name="codtpe" [(ngModel)]="objCliente.codtpe"
                                                            #selectInsertar tabindex="1">
                                                            <option *ngFor="let lst of tipopersona"
                                                                value="{{lst.codtpe}}">
                                                                {{lst.destpe}}</option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>

                                                    <label for="fname2"
                                                        class="col-md-1 text-left control-label col-form-label">Ingreso:
                                                    </label>
                                                    <div class="col-sm-2">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.fecing" name="fecing" maxlength="3">
                                                    </div>
                                                    <div class="col-sm-3" style="margin-left: 2em;">
                                                        <input disabled type="checkbox" class="form-check-input"
                                                            id="exampleCheck1" [(ngModel)]="objCliente.valident"
                                                            name="valident">
                                                        <label class="tsiLabel form-check-label"
                                                            for="exampleCheck1">Valida
                                                            identidad</label>
                                                    </div>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Tipo de
                                                        identidad:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <select disabled
                                                            style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                            class="custom-select"
                                                            class="form-control tsiInput select_border" id="tident"
                                                            (change)="onSelectTipoIdentidadIns($event.target.value)"
                                                            name="tident" [(ngModel)]="objCliente.tident" tabindex="4">
                                                            <option *ngFor="let tipdoci of identidades ;"
                                                                value="{{tipdoci.tident}}">
                                                                {{tipdoci.descri}}</option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>

                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Doc. de
                                                        identidad:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.dident" name="dident" maxlength="20"
                                                            tabindex="5">
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Código:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.codcli" name="codcli" maxlength="20"
                                                            tabindex="6" disabled>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>

                                                <div *ngIf="tident=='06'">
                                                    <div class="form-group row" style="margin-bottom: 0px;">
                                                        <label for="fname2"
                                                            class="col-md-2 text-left control-label col-form-label">Apellidos
                                                            y
                                                            nombres:
                                                        </label>
                                                        <div class="col-sm-8">
                                                            <input disabled type="text" class="form-control tsiInput"
                                                                [(ngModel)]="objCliente.razonc"
                                                                (keyup)="onKeyUpNombresCompletos($event)" name="razonc"
                                                                maxlength="80" tabindex="7">
                                                        </div>
                                                        <span style="color: red; font: sans-serif;">(*)</span>
                                                    </div>
                                                </div>
                                                <div *ngIf="tident!='06'">
                                                    <div class="form-group row" style="margin-bottom: 0px;">
                                                        <label for="fname2"
                                                            class="col-md-2 text-left control-label col-form-label">Razón
                                                            social:
                                                        </label>
                                                        <div class="col-sm-8">
                                                            <input disabled type="text" class="form-control tsiInput"
                                                                [(ngModel)]="objCliente.razonc" name="razonc"
                                                                maxlength="100" tabindex="7">
                                                        </div>
                                                        <span style="color: red; font: sans-serif;">(*)</span>
                                                    </div>
                                                </div>

                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Dirección
                                                        1:
                                                    </label>
                                                    <div class="col-sm-8">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.direc1" name="direc1"
                                                            maxlength="100" tabindex="8">
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Dirección
                                                        2:
                                                    </label>
                                                    <div class="col-sm-8">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.direc2" name="direc2"
                                                            maxlength="100" tabindex="9">
                                                    </div>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Apellido
                                                        paterno:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.apellidopaterno"
                                                            name="apellidopaterno" maxlength="15" tabindex="10">
                                                    </div>

                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Correo
                                                        electrónico:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.email" name="email" maxlength="50"
                                                            tabindex="11">
                                                    </div>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Apellido
                                                        materno:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.apeliidomaterno"
                                                            name="apeliidomaterno" maxlength="15" tabindex="12">
                                                    </div>

                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Teléfono:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.telefono" name="telefono"
                                                            maxlength="30" tabindex="13">
                                                    </div>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Nombres:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.nombres" name="nombres"
                                                            maxlength="30" tabindex="14">
                                                    </div>

                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Celular:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.fax" name="fax" maxlength="30"
                                                            tabindex="15">
                                                    </div>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">DNI:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <input disabled type="text" class="form-control tsiInput"
                                                            [(ngModel)]="objCliente.nrodni" name="nrodni" maxlength="7"
                                                            tabindex="16"
                                                            onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                    </div>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Sexo:
                                                    </label>
                                                    <div class="col-sm-3">
                                                        <select disabled tabindex="17"
                                                            style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                            class="custom-select"
                                                            class="form-control tsiInput select_border" id="sexo"
                                                            name="sexo" [(ngModel)]="objCliente.sexo">
                                                            <option value="M">Masculino</option>
                                                            <option value="F">Femenino</option>
                                                        </select>
                                                    </div>


                                                </div>

                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Vendedor:
                                                    </label>
                                                    <div class="col-sm-4">
                                                        <select disabled
                                                            style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                            class="custom-select"
                                                            class="form-control tsiInput select_border"
                                                            id="objCliente.codven" name="objCliente.codven"
                                                            [(ngModel)]="objCliente.codven" tabindex="19">
                                                            <option *ngFor="let vend of vendedor ;"
                                                                value="{{vend.codven}}">
                                                                {{vend.descven}}</option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>

                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0px;">

                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Título
                                                        de
                                                        lista:
                                                    </label>
                                                    <div class="col-sm-4">
                                                        <select disabled
                                                            style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                            class="custom-select"
                                                            class="form-control tsiInput select_border"
                                                            id="objCliente.codtit" name="objCliente.codtit"
                                                            [(ngModel)]="objCliente.codtit" tabindex="18">
                                                            <option *ngFor="let tit of titulolista ;"
                                                                value="{{tit.codtit}}">
                                                                {{tit.titulo}}</option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>

                                                </div>

                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Concepto
                                                        impositivo:
                                                    </label>
                                                    <div class="col-sm-5">
                                                        <select disabled
                                                            style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                            class="custom-select"
                                                            class="form-control tsiInput select_border"
                                                            id="objCliente.regret" name="objCliente.regret"
                                                            [(ngModel)]="objCliente.regret" tabindex="20">
                                                            <option *ngFor="let lst of clienteRegimenes ;"
                                                                value="{{lst.codigo}}">
                                                                {{lst.descri}}</option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>

                                                <div class="form-group row" style="margin-bottom: 0px;">
                                                    <label for="fname2"
                                                        class="col-md-2 text-left control-label col-form-label">Observación:
                                                    </label>
                                                    <div class="col-sm-8">
                                                        <textarea disabled
                                                            class="form-control form-control-sm select_border"
                                                            id="observ" name="observ" [(ngModel)]="objCliente.observ"
                                                            style="text-transform:uppercase;" type="text" rows="6"
                                                            maxlength="980" tabindex="21"></textarea>
                                                    </div>
                                                </div>
                                               
                                            </div>
                                        </div>
                                        <hr>
                                        <!-- <div class="form-group row mb-1">
                                            <label for="fname2" class="col-md-1 text-left control-label ">Creación:
                                            </label>
                                            
                                                <input  type="date" disabled
                                                    class="focus-input input_border form-control tsiInput col-sm-2"
                                                   >
                                            
                                            <label for="fname2" class="col-md-1 text-left control-label ">Usuario:
                                            </label>
                                          
                                                <input  type="text" disabled
                                                    class="focus-input input_border form-control  tsiInput col-sm-2">
                                           
                                            <label for="fname2" class="col-md-1 text-left control-label ">Ultima act.
                                            </label>
                                            
                                                <input  type="date" disabled
                                                    class="focus-input input_border form-control  tsiInput col-sm-2">
                                            
                                            <label for="fname2" class="col-md-1 text-left control-label ">Usuario:
                                            </label>
                                                <input  type="text" disabled
                                                    class="focus-input input_border form-control  tsiInput col-sm-2">
                                        </div> -->
                                    </div>
                                </ng-template>

                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle><b>Clases</b></ng-template>
                                <ng-template ngbTabContent>
                                    <br>

                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Clase</th>
                                                    <th>Descripción</th>
                                                    <th>Código</th>
                                                    <th>Descripción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of clases">
                                                    <td scope="row">{{ item.clase }}</td>
                                                    <td style="white-space: nowrap;">{{ item.desclase }}</td>
                                                    <td scope="row">{{ item.codigo }}</td>
                                                    <td style="white-space: nowrap;">{{ item.descodigo }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                </ng-template>

                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>

                                <ng-template ngbTabTitle><b>Créditos</b></ng-template>
                                <ng-template ngbTabContent>
                                    <hr>
                                    <form autocomplete="off">
                                        <div class="row">
                                            <div class=" col-md-4 m-r-10">
                                                <div class="form-group row">
                                                    <label for="fname2"
                                                        class="col-md-3 control-label col-form-label">Crédito</label>
                                                    <div class="col-md-6">
                                                        <div class="check-list">
                                                            <label class="ui-radio">
                                                                <input disabled type="radio" value="0"
                                                                    [(ngModel)]="objCliente.credito" name="codpag">
                                                                <span class="input-span"></span> 0-Cerrado
                                                            </label>
                                                            <br>
                                                            <label class="ui-radio">
                                                                <input disabled type="radio" value="1"
                                                                    [(ngModel)]="objCliente.credito" name="codpag">
                                                                <span class="input-span"></span> 1-Abierto
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class=" col-md-7">

                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <label for="fname2"
                                                        class="col-md-4 control-label col-form-label">Límite
                                                        de crédito
                                                        {{ _monedaFactor }}:
                                                    </label>
                                                    <div class="col-md-3">
                                                        <input disabled type="text"
                                                            class="form-control form-control-sm text-right"
                                                            [(ngModel)]="viewlimiteCredito" id="viewlimiteCredito"
                                                            name="viewlimiteCredito" maxlength="7" tabindex="1"
                                                            (blur)="decimalFormatLimiteCredito(viewlimiteCredito)"
                                                            onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                    </div>
                                                </div>

                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <label for="fname2"
                                                        class="col-md-4 control-label col-form-label">Días
                                                        de gracia</label>
                                                    <div class="col-md-3">
                                                        <input disabled type="text"
                                                            class="form-control form-control-sm text-right"
                                                            [(ngModel)]="objCliente.diasgracia" id="diasgracia"
                                                            #descsucmod name="diasgracia" maxlength="5" tabindex="1"
                                                            onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </form>
                                </ng-template>

                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>

                                <ng-template ngbTabTitle><b>Condiciones de pago</b></ng-template>
                                <ng-template ngbTabContent>
                                    <hr>


                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Descripción</th>
                                                    <th>Usuario</th>
                                                    <th class="text-center">Predeterminado</th>
                                                    <th class="text-center">Activo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of condicionesPago">
                                                    <td scope="row">{{ item.codpag }}</td>
                                                    <td style="white-space: nowrap;">{{ item.despag }}</td>
                                                    <td scope="row">{{ item.usuario }}</td>
                                                    <td>
                                                        <div style="text-align: center;"
                                                            *ngIf="item.predeterminado == true"> <i
                                                                class="fas fa-check fa-lg" style="color: green;"></i>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div style="text-align: center;" *ngIf="item.activo == true"> <i
                                                                class="fas fa-check fa-lg" style="color: green;"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>

                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>

                                <ng-template ngbTabTitle><b>Contactos</b></ng-template>
                                <ng-template ngbTabContent>
                                    <hr>
                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Contacto</th>
                                                    <th>Cargo</th>
                                                    <th>Email</th>
                                                    <th>Teléfono</th>
                                                    <th class="text-center">Activo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of contactos">
                                                    <td scope="row">{{ item.codcont }}</td>
                                                    <td style="white-space: nowrap;">{{ item.nomcont }}</td>
                                                    <td style="white-space: nowrap;">{{ item.cargo }}</td>
                                                    <td style="white-space: nowrap;">{{ item.correo }}</td>
                                                    <td style="white-space: nowrap;">{{ item.telefono }}</td>
                                                    <td>
                                                        <div style="text-align: center;" *ngIf="item.activo == true"> <i
                                                                class="fas fa-check fa-lg" style="color: green;"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>

                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle><b>Especificaciones</b></ng-template>
                                <ng-template ngbTabContent>
                                    <hr>
                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Descripción</th>
                                                    <th>V. Decimal</th>
                                                    <th>V. Cadena</th>
                                                    <th>V. Caracter</th>
                                                    <th>V. Fecha</th>
                                                    <th>V. Entero</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of especificaciones">
                                                    <td scope="row">{{ item.codesp }}</td>
                                                    <td style="white-space: nowrap;">{{ item.descri }}</td>
                                                    <td style="white-space: nowrap;">{{ item.vreal }}</td>
                                                    <td style="white-space: nowrap;">{{ item.vstrg }}</td>
                                                    <td style="white-space: nowrap;">{{ item.vchar }}</td>
                                                    <td style="white-space: nowrap;">{{ item.vdate }}</td>
                                                    <td style="white-space: nowrap;">{{ item.ventero }}</td>

                                                    <td>
                                                        <div style="text-align: center;" *ngIf="item.activo == true"> <i
                                                                class="fas fa-check fa-lg" style="color: green;"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle><b>Direcciones de envío</b></ng-template>
                                <ng-template ngbTabContent>
                                    <hr>

                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Código</th>
                                                    <th>Almacén</th>
                                                    <th>Dirección 1</th>
                                                    <th>Dirección 2</th>
                                                    <th class="text-center">Activo</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of direcciones">

                                                    <td scope="row">{{ item.codenv }}</td>
                                                    <td style="white-space: nowrap;">{{ item.descri }}</td>
                                                    <td style="white-space: nowrap;">{{ item.direc1 }}</td>
                                                    <td style="white-space: nowrap;">{{ item.direc2 }}</td>
                                                    <!-- <td style="white-space: nowrap;">{{ item.telefono }}</td> -->
                                                    <td>
                                                        <div style="text-align: center;" *ngIf="item.swacti == 'S'"> <i
                                                                class="fas fa-check fa-lg" style="color: green;"></i>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </ngb-tab>
                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle><b>Bancos</b></ng-template>
                                <ng-template ngbTabContent>
                                    <hr>

                                    <div class="table-responsive">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Entidad Financiera</th>
                                                    <th>Tipo Cuenta EEFF</th>
                                                    <th>Moneda</th>
                                                    <th>Cuenta</th>
                                                    <!-- <th class="text-center">Activo</th> -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of bancos">
                                                    <td style="white-space: nowrap;">{{ item.desban }}</td>
                                                    <td style="white-space: nowrap;">{{ item.descta }}</td>
                                                    <td style="white-space: nowrap;">{{ item.tipmon }}</td>
                                                    <td style="white-space: nowrap;">{{ item.cuenta }}</td>
                                                    <!-- <td>
                            <div style="text-align: center;" *ngIf="item.activo == true"> <i class="fas fa-check fa-lg"
                                style="color: green;"></i></div>
                            </td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </ngb-tab>

                            <!-- cotizaciones -->
                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle> <span (click)="situacCotizaciones()">Cotizaciones</span>
                                </ng-template>
                                <ng-template ngbTabContent>

                                    <br>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 form-control-label">Filtrar por fecha</label>
                                        <div class="input-group col-sm-5">
                                            <label class="col-form-label m-r-5">Desde</label>
                                            <input class="form-control form-control-sm m-r-10" id="fechaDesde"
                                                name="fechaDesde" [(ngModel)]="fechaDesde" type="date" max="2999-01-01"
                                                tabindex="1">

                                            <label class="col-form-label m-r-5">Hasta</label>
                                            <input class="form-control form-control-sm" id="fechaHasta"
                                                name="fechaHasta" [(ngModel)]="fechaHasta" type="date" max="2999-01-01"
                                                tabindex="2">
                                        </div>
                                    </div>


                                    <!--TIPO DE INVENTARIO-->
                                    <div class="form-group row" style="margin-bottom: 0px;">

                                        <label for="fname2" class="col-md-2 control-label col-form-label">
                                            Sucursal:
                                        </label>


                                        <div class="col-sm-3">
                                            <select
                                                style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                tabindex="2" [(ngModel)]="_codSucursal" name="_codSucursal"
                                                class="custom-select border-consulta" class="form-control tsiInput">
                                                <option *ngFor="let lst of sessionInfo.sucursales" [value]="lst.codsuc">
                                                    {{lst.codsuc+' - '+lst.sucursal}}
                                                </option>
                                            </select>
                                        </div>

                                    </div>






                                    <div class="form-group row">

                                        <label class="col-md-2 text-left control-label col-form-label">
                                            Situación</label>

                                        <div class="col-sm-10">

                                            <div class="row">




                                                <div *ngFor="let lst of situaciones" class="col-sm-3"
                                                    style="margin-bottom: auto !important;">
                                                    <label class="ui-checkbox ui-checkbox-inline">
                                                        <input id="codSituacion" [ngModelOptions]="{standalone: true}"
                                                            (change)="onChangeSituacs(lst.situac,$event.target.checked)"
                                                            [(ngModel)]="lst.checked" value="{{lst.situac}}"
                                                            type="checkbox">
                                                        <span class="input-span"></span>{{lst.situacDesc}}
                                                    </label>
                                                </div>


                                            </div>


                                            <div class="form-group border-consulta2">
                                                <!-- <label class="form-control-label tamano-consulta">Filtrar por
                                                    situación</label> -->

                                            </div>
                                            <div class="form-row m-b-10">
                                                <label class="ui-checkbox ui-checkbox-inline"
                                                    style="padding-left: 6px; margin-top: -15px;">
                                                    <input id="select_all" (click)="CheckAllOptions()"
                                                        [(ngModel)]="check" name="check" type="checkbox"
                                                        style="margin-right: 10px;">
                                                    <span class="input-span"></span>Todos
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="button" class="btn btn-rounded btn-info m-b-15"
                                        (click)="buscarCotizaciones()"><i class="fa fa-search"></i>
                                        Buscar </button>

                                    <p *ngIf="cotizaciones != null && cotizaciones.length > 0">Últimos 100
                                        registros
                                    </p>

                                    <div class="table-responsive" style="height:75vh;">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th class="text-center"> </th>
                                                    <th style="text-align: center; width: 100px;">#Interno</th>
                                                    <th style="text-align: left;">Situación</th>
                                                    <th style="text-align: left;">Serie</th>
                                                    <th style="text-align: left;">Número</th>
                                                    <th style="white-space: nowrap; text-align: left;">F. Emisión</th>
                                                    <th style="text-align: left;">Razón social</th>
                                                    <th style="text-align: left;">Moneda</th>
                                                    <th style="text-align: right;">Venta Inafecto</th>

                                                    <th style="text-align: right;">Venta Afecto</th>

                                                    <th style="text-align: right;">IGV</th>
                                                    <th style="text-align: right;">Precio Venta</th>
                                                    <!-- <th style="text-align: left;">Vendedor</th> -->
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let coti of cotizaciones" (click)="onClick(coti)"
                                                    [ngClass]="{'nombre-de-la-clase': coti == this.cotitemp}">

                                                    <!-- <td style="text-align: center;">
                                                        <input type="radio" (change)="onChangeCotizacion(coti)" tabindex="13" name="radio">
                                                    </td> -->

                                                    <td style="text-align: center;">

                                                        <div class="btn-group dropright" ngbDropdown container="body"
                                                            role="group" aria-label="Button group with nested dropdown"
                                                            style="margin: 0px; padding: 0px;">
                                                            <button class="btn btn-sm" ngbDropdownToggle
                                                                style="margin: 0px; padding: 0px;">
                                                                <i class=" fas fa-align-left"></i>
                                                            </button>
                                                            <div class="dropdown-menu" ngbDropdownMenu>

                                                                <button class="dropdown-item"
                                                                    (click)="trazabilidad(coti)"><i
                                                                        class="fas fa-copy font-14"
                                                                        style="margin-right: .3rem"></i>
                                                                    Trazabilidad</button>

                                                            </div>
                                                            <div class="dropdown-menu" ngbDropdownMenu>

                                                                <button class="dropdown-item"
                                                                    (click)="trazabilidad(coti)"><i
                                                                        class="fas fa-copy font-14"
                                                                        style="margin-right: .3rem"></i>
                                                                    Trazabilidad</button>

                                                            </div>
                                                        </div>

                                                    </td>

                                                    <td style="text-align: center;">{{coti.numint}}</td>
                                                    <td style="white-space: nowrap; text-align: left;">
                                                        {{coti.situacNombre}}</td>
                                                    <td style="text-align: left;">{{coti.serie}}</td>
                                                    <td style="text-align: left;">{{coti.numero}}</td>
                                                    <td style="white-space: nowrap; text-align: left;">{{coti.femisi |
                                                        date:'dd/MM/yyyy'}}
                                                    </td>
                                                    <td style="white-space: nowrap; text-align: left;">
                                                        {{coti.razonsocial}}</td>
                                                    <td style="text-align: left;">{{coti.moneda}}</td>
                                                    <td style="text-align: right;">{{coti.monina | number:'.2-2' }}</td>
                                                    <td style="text-align: right;">{{ coti.monafe | number:'.2-2' }}
                                                    </td>
                                                    <td style="text-align: right;">{{coti.monigv | number:'.2-2' }}</td>
                                                    <td style="text-align: right;">{{coti.preven | number:'.2-2' }}</td>
                                                    <!-- <td style="text-align: left;">{{ coti.vendedor }}</td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>






                                </ng-template>

                            </ngb-tab>
                            <!--Este es ventas-->








                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle> <span>Ventas</span></ng-template>
                                <ng-template ngbTabContent>
    
    
                                    <br>
                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 form-control-label">Filtrar por fecha: </label>
                                        <div class="input-group col-sm-5">
                                            <label class="col-form-label m-r-5">Desde</label>
                                            <input class="form-control form-control-sm m-r-10" id="desde"
                                                name="desde" [(ngModel)]="desde" type="date" max="2999-01-01"
                                                tabindex="1">

                                            <label class="col-form-label m-r-5">Hasta</label>
                                            <input class="form-control form-control-sm" id="fechaHasta1"
                                                name="fechaHasta1" [(ngModel)]="fechaHasta1" type="date" max="2999-01-01"
                                                tabindex="2">
                                        </div>
                                    </div>
    
                                    <!--TIPO DE INVENTARIO-->
                                    <div class="form-group row" style="margin-bottom: 0px;">
    
                                        <label for="fname2" class=" col-md-2 control-label col-form-label">
                                            Sucursal:
                                        </label>
    
    
                                        <div class="col-sm-3">
                                            <select style="margin-bottom: 12px !important ; padding-top: 0px !important;" tabindex="2" [(ngModel)]="_codSucursal" name="_codSucursal" class="custom-select select_border" class="form-control tsiInput">
                                                <option value="-1">Todos</option>
                                                <option *ngFor="let lst of sessionInfo.sucursales" [value]="lst.codsuc">
                                                    {{lst.codsuc+' - '+lst.sucursal}}
                                                </option>
                                            </select>
                                        </div>
    
                                    </div>
                                    <div class="form-group row" style="margin-bottom: 0px;">

                                        <label for="fname2" class=" col-md-2 text-left control-label col-form-label">Tipo
                                            de inventario:
                                        </label>
                                        <div class="col-sm-1" >
                                            <input [disabled]="disabledArticulo" style="text-align: center;" (keydown.enter)="onKeyEnterTipodeInventario($event)" (blur)="onBlurTipodeInventario($event)" class="form-control tsiInput" #selectTipoInventario [(ngModel)]="objarticulo.tipinv" name="inputtipiv"
                                                maxlength="2" type="text" tabindex="1" onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                        </div>

                                        <div class="col-sm-3">
                                            <select [disabled]="disabledArticulo" id="cboTipoInventario" style="margin-bottom: 12px !important ; padding-top: 0px !important;" tabindex="2" [(ngModel)]="objarticulo.tipinv" name="cobTipoInventario" class="custom-select" class="form-control tsiInput">
                                                <option value="-1">Todos</option>
                                                <option *ngFor="let lst of tiposInventario "
                                                    [value]="lst.tipinv">
                                                    {{lst.tipinv+' - '+lst.dtipinv}}
                                                </option>
                                            </select>
                                        </div>
                                       <!--  <span style="color: red; font: sans-serif;">(*)</span> -->

                                    </div>
    
                                    <div class="form-group row" style="margin-bottom: 0px;">
    
                                        <label class="col-md-2 text-left control-label col-form-label">Artículo: </label>
    
    
                                        <div class="col-sm-2">
                                            <input type="text" class="form-control tsiInput" name="codArticulo" [(ngModel)]="objarticulo.codart" [disabled]="disabledArticulo" #selectTipoInventario tabindex="5" data-toggle="tooltip" data-placement="top" title="MÁXIMO DE 20 CARACTERES" data-original-title="MÁXIMO DE 20 CARACTERES"
                                                (keydown.enter)="onKeyEnterCodigoArticulo($event)" #interlocutor
                                                placeholder="Código..." maxlength="13">
                                        </div>
                                        <div class="col-sm-6">
                                            <input id="desarticulo"type="text" class="custom-select" class="form-control tsiInput select_border" name="desarticulo" [(ngModel)]="objarticulo.descri" style="margin-bottom: 12px !important ; padding-top: 0px !important;" [disabled]="disabledArticulo" tabindex="6"
                                                #razon (keydown.enter)="onKeyEnterArticulo($event)">
                                        </div>
    
    
                                        <div class="input-group-btn">
                                            <button *ngIf="buscarArticulo == 'buscar'" class="btn btn-primary btn-sm boton m-b-5" (click)="openModalArticulo()" type="button" tabindex="7"[disabled]="disabledArticulo"><i class="fa fa-search"></i></button>
                                            <button *ngIf="buscarArticulo == 'borrar'" class="btn btn-primary btn-sm boton m-b-5" (click)="borrarDatosArticulo()" type="button" tabindex="7" ><i
                                                    class="fas fa-times"></i></button>
                                        </div>
                                        <div class="form-row m-b-10 ml-3">
                                            <label class="ui-checkbox ui-checkbox-inline"
                                                style="padding-left: 6px; margin-right: 15px;">
                                                <input id="select_all" (change)="onChangeArticuloResumen()"
                                                [(ngModel)]="articuloTodos"
                                                     name="articuloTodos" type="checkbox"
                                                    style="margin-right: 10px;" checked >
                                                <span class="input-span"></span>Todos
                                            </label>
                                        </div>
                                        
                                    </div>
    
    
                                    <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="buscarVentas()"><i class="fa fa-search"></i>
                                            Buscar 
                                    </button>
    
                                    <br>
                                    <p *ngIf="sp_ventas != null && sp_ventas.length > 0">Últimos 100 registros</p>
                                    <div class="table-responsive" style="height: 400px;">
                                        <table id="frmConsultaClientes" class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th class="text-center"><i class="fas fa-bullseye"></i> </th>
    
                                                    <th id="fEmision" *ngIf="campos[0]!=null && campos[0].visible">{{campos[0].caption}}</th>
                                                    <th id="situacion" *ngIf="campos[1]!=null && campos[1].visible">{{campos[1].caption}}</th>
                                                    <th id="serie" *ngIf="campos[2]!=null && campos[2].visible">{{campos[2].caption}}</th>
                                                    <th id="numero" *ngIf="campos[3]!=null && campos[3].visible">{{campos[3].caption}}</th>
                                                    <th id="razonSocial" *ngIf="campos[4]!=null && campos[4].visible">{{campos[4].caption}}</th>
                                                    <th id="almacen" *ngIf="campos[5]!=null && campos[5].visible">{{campos[5].caption}}</th>
                                                    <th id="codArticulo" *ngIf="campos[6]!=null && campos[6].visible">{{campos[6].caption}}</th>
                                                    <th id="descArticulo" *ngIf="campos[7]!=null && campos[7].visible" >{{campos[7].caption}}</th>
                                                    <th id="cant" style="text-align: right;" *ngIf="campos[8]!=null && campos[8].visible">{{campos[8].caption}}</th>
                                                    <th id="largo" style="text-align: right;" *ngIf="campos[9]!=null && campos[9].visible">{{campos[9].caption}}</th>
    
                                                    <th id="incIgv" style="text-align: right; white-space: nowrap;" *ngIf="campos[10]!=null && campos[10].visible">{{campos[10].caption}}</th>
                                                    <th id="preUniS" style="text-align: right; white-space: nowrap;" *ngIf="campos[11]!=null && campos[11].visible">{{campos[11].caption}}</th>
                                                    <th id="preUniD" style="text-align: right; white-space: nowrap;" *ngIf="campos[12]!=null && campos[12].visible">{{campos[12].caption}}</th>
    
                                                    <th id="desc1" class="text-right" style="white-space: nowrap;" *ngIf="campos[13]!=null && campos[13].visible">{{campos[13].caption}}</th>
                                                    <th id="desc2" class="text-right" style="white-space: nowrap;" *ngIf="campos[14]!=null && campos[14].visible">{{campos[14].caption}}</th>
                                                    <th  id="desc3"class="text-right" style="white-space: nowrap;" *ngIf="campos[15]!=null && campos[15].visible">{{campos[15].caption}}</th>
                                                    <th  id="desc4"class="text-right" style="white-space: nowrap;" *ngIf="campos[16]!=null && campos[16].visible">{{campos[16].caption}}</th>
    
    
                                                    <th id="totalS" style="text-align: right; white-space: nowrap;" *ngIf="campos[17]!=null && campos[17].visible">{{campos[17].caption}}</th>
                                                    <th id="totalD" style="text-align: right; white-space: nowrap;" *ngIf="campos[18]!=null && campos[18].visible">{{campos[18].caption}}</th>
                                                    <th id="codVendedor" *ngIf="campos[19]!=null && campos[19].visible">{{campos[19].caption}}</th>
                                                    <th id="descVendedor" *ngIf="campos[20]!=null && campos[20].visible">{{campos[20].caption}}</th>
                                                    <th id="motivo" *ngIf="campos[21]!=null && campos[21].visible">{{campos[21].caption}}</th>
                                                    <th id="descMotivo" *ngIf="campos[22]!=null && campos[22].visible">{{campos[22].caption}}</th>
                                                    <th id="condPago" *ngIf="campos[23]!=null && campos[23].visible">{{campos[23].caption}}</th>
                                                    <th id="descPago" *ngIf="campos[24]!=null && campos[24].visible">{{campos[24].caption}}</th>
    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let lst of sp_ventas">
    
    
                                                    <td>
    
                                                        <div class="btn-group dropright" ngbDropdown container="body" role="group" aria-label="Button group with nested dropdown" style="margin: 0px; padding: 0px;">
                                                            <button class="btn btn-sm" ngbDropdownToggle style="margin: 0px; padding: 0px;">
                                                                <i class=" fas fa-align-left"></i>
                                                            </button>
                                                            <div class="dropdown-menu" ngbDropdownMenu>
    
                                                                <button class="dropdown-item" (click)="trazabilidad(lst)"><i
                                                                        class="fas fa-copy font-14"
                                                                        style="margin-right: .3rem"></i>
                                                                    Trazabilidad</button>
                                                                <button class="dropdown-item" (click)="openModalDocumento(lst)"><i
                                                                        class="fas fa-copy font-14"
                                                                        style="margin-right: .3rem"></i>
                                                                    Detalle documento</button>
                                                            </div>
    
                                                        </div>
    
    
                                                    </td>
    
    
                                                    <td  *ngIf="campos[0].visible">{{ lst.femisi | date:'dd/MM/yyyy' }}</td>
                                                    <td   *ngIf="campos[1].visible"style="white-space: nowrap;">{{ lst.dessit }}</td>
                                                    <td  *ngIf="campos[2].visible">{{ lst.series }} </td>
                                                    <td  *ngIf="campos[3].visible">{{ lst.numdoc }} </td>
                                                    <td   *ngIf="campos[4].visible" style="white-space: nowrap;">{{ lst.razonc }} </td>
                                                    <td   *ngIf="campos[5].visible"style="white-space: nowrap;">{{ lst.desalm }} </td>
                                                    <td   *ngIf="campos[6].visible" style="white-space: nowrap;">{{ lst.codart }} </td>
                                                    <td  *ngIf="campos[7].visible" style="white-space: nowrap;">{{ lst.desart}} </td>
                                                    <td   *ngIf="campos[8].visible" style="text-align: right;">{{ lst.cantid | number:'.2-2' }}
                                                    </td>
                                                    <td   *ngIf="campos[9].visible" style="text-align: right;">{{ this.largo | number:'.2-2' }}</td>
    
                                                    <td  *ngIf="campos[10].visible">{{ lst.incigv }} </td>
    
    
    
                                                    <td  *ngIf="campos[11].visible" style="text-align: right;">{{ lst.preunisol | number:'.2-2' }}
                                                    </td>
                                                    <td  *ngIf="campos[12].visible" style="text-align: right;">{{ lst.preunidol | number:'.2-2' }}
                                                    </td>
    
                                                    <td    *ngIf="campos[13].visible"class="text-right">{{ lst.pordes1 | number:'.2-2' }} </td>
                                                    <td  *ngIf="campos[14].visible" class="text-right">{{ lst.pordes2 | number:'.2-2' }} </td>
                                                    <td  *ngIf="campos[15].visible" class="text-right">{{ lst.pordes3 | number:'.2-2' }} </td>
                                                    <td  *ngIf="campos[16].visible" class="text-right">{{ lst.pordes4 | number:'.2-2' }} </td>
    
    
                                                    <td  *ngIf="campos[17].visible" style="text-align: right;">{{ lst.pretotsol | number:'.2-2' }}
                                                    </td>
                                                    <td   *ngIf="campos[18].visible" style="text-align: right;">{{ lst.pretotdol | number:'.2-2' }}
                                                    </td>
                                                    <td  *ngIf="campos[19].visible" style="white-space: nowrap;">{{ lst.codven }} </td>
                                                    <td  *ngIf="campos[20].visible" style="white-space: nowrap;">{{ lst.desven}} </td>
                                                    <td  *ngIf="campos[21].visible" style="white-space: nowrap;">{{ lst.codmot }} </td>
                                                    <td  *ngIf="campos[22].visible" style="white-space: nowrap;">{{ lst.desmot}} </td>
                                                    <td  *ngIf="campos[23].visible" style="white-space: nowrap;">{{ lst.codcpag }} </td>
                                                    <td  *ngIf="campos[24].visible" style="white-space: nowrap;">{{ lst.despag}} </td>
    
    
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
    
    
    
                                </ng-template>
    
                            </ngb-tab>
                            
                            <!-- cotizaciones -->
                            <ngb-tab *ngIf=mostrar>
                                <ng-template ngbTabTitle> <span (click)="situacPedidos()">Pedidos</span>
                                </ng-template>
                                <ng-template ngbTabContent>


                                    <br>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 form-control-label">Filtrar por fecha</label>
                                        <div class="input-group col-sm-5">
                                            <label class="col-form-label m-r-5">Desde</label>
                                            <input class="form-control form-control-sm m-r-10" id="fechaDesde"
                                                name="fechaDesde" [(ngModel)]="fechaDesde" type="date" max="2999-01-01"
                                                tabindex="1">

                                            <label class="col-form-label m-r-5">Hasta</label>
                                            <input class="form-control form-control-sm" id="fechaHasta"
                                                name="fechaHasta" [(ngModel)]="fechaHasta" type="date" max="2999-01-01"
                                                tabindex="2">
                                        </div>
                                    </div>


                                    <!--TIPO DE INVENTARIO-->
                                    <div class="form-group row" style="margin-bottom: 0px;">

                                        <label for="fname2" class="col-md-2 control-label col-form-label">
                                            Sucursal:
                                        </label>


                                        <div class="col-sm-3">
                                            <select
                                                style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                tabindex="2" [(ngModel)]="_codSucursal" name="_codSucursal"
                                                class="custom-select border-consulta" class="form-control tsiInput">
                                                <option *ngFor="let lst of sessionInfo.sucursales" [value]="lst.codsuc">
                                                    {{lst.codsuc+' - '+lst.sucursal}}
                                                </option>
                                            </select>
                                        </div>

                                    </div>






                                    <div class="form-group row">

                                        <label class="col-md-2 text-left control-label col-form-label">
                                            Situación</label>

                                        <div class="col-sm-10">

                                            <div class="row">




                                                <div *ngFor="let lst of situaciones" class="col-sm-3"
                                                    style="margin-bottom: auto !important;">
                                                    <label class="ui-checkbox ui-checkbox-inline">
                                                        <input id="codSituacion" [ngModelOptions]="{standalone: true}"
                                                            (change)="onChangeSituacs(lst.situac,$event.target.checked)"
                                                            [(ngModel)]="lst.checked" value="{{lst.situac}}"
                                                            type="checkbox">
                                                        <span class="input-span"></span>{{lst.situacDesc}}
                                                    </label>
                                                </div>


                                            </div>


                                            <div class="form-group border-consulta2">
                                                <!-- <label class="form-control-label tamano-consulta">Filtrar por
                                                    situación</label> -->

                                            </div>
                                            <div class="form-row m-b-10">
                                                <label class="ui-checkbox ui-checkbox-inline"
                                                    style="padding-left: 6px; margin-top: -15px;">
                                                    <input id="select_all" (click)="CheckAllOptions()"
                                                        [(ngModel)]="check" name="check" type="checkbox"
                                                        style="margin-right: 10px;">
                                                    <span class="input-span"></span>Todos
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="button" class="btn btn-rounded btn-info m-b-15"
                                        (click)="buscarPedidos()"><i class="fa fa-search"></i>
                                        Buscar </button>

                                    <p *ngIf="pedidos != null && pedidos.length > 0">Últimos 100
                                        registros
                                    </p>


                                    <div class="table-responsive" style="height:75vh;">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th class="text-center"><i class="fas fa-bullseye"></i> </th>
                                                    <th style="text-align: center; width: 100px;">#Interno</th>
                                                    <th style="text-align: left;">Situación</th>
                                                    <th class="text-left; white-space: nowrap;"> Estado </th>
                                                    <th style="text-align: left;">Serie</th>
                                                    <th style="text-align: left;">Número</th>
                                                    <th style="text-align: left;">F.Emisión </th>
                                                    <th style="white-space: nowrap; text-align: left;">Razón Social</th>
                                                    <th style="text-align: left;">Moneda</th>
                                                    <th style="text-align: right;">Venta Inafecto</th>
                                                    <th style="text-align: right;">Venta Afecto</th>
                                                    <th style="text-align: right;">IGV</th>
                                                    <th style="text-align: right;">Precio Venta</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let coti of pedidos"
                                                    [ngClass]="{'nombre-de-la-clase': coti == this.cotitemp}">
                                                    <td style="text-align: center;">
                                                        <div class="btn-group dropright" ngbDropdown container="body"
                                                            role="group" aria-label="Button group with nested dropdown"
                                                            style="margin: 0px; padding: 0px;">
                                                            <button class="btn btn-sm" ngbDropdownToggle
                                                                style="margin: 0px; padding: 0px;">
                                                                <i class=" fas fa-align-left"></i>
                                                            </button>
                                                            <div class="dropdown-menu" ngbDropdownMenu>


                                                                <button class="dropdown-item"
                                                                    (click)="trazabilidad(coti)"><i
                                                                        class="fas fa-copy font-14"
                                                                        style="margin-right: .3rem"></i>
                                                                    Trazabilidad</button>

                                                            </div>

                                                        </div>

                                                    </td>

                                                    <td style="text-align: center;">{{coti.numint}}</td>
                                                    <td style="white-space: nowrap; text-align: left;">
                                                        {{coti.situacNombre}}</td>
                                                    <td style="white-space: nowrap; text-align: left;">
                                                        {{coti.situacda}} </td>
                                                    <td style="text-align: left;">{{coti.serie}}</td>
                                                    <td style="text-align: left;">{{coti.numero}}</td>
                                                    <td style="white-space: nowrap; text-align: left;">{{coti.femisi |
                                                        date:'dd/MM/yyyy'}}
                                                    </td>
                                                    <td style="white-space: nowrap; text-align: left;">
                                                        {{coti.razonsocial}}</td>
                                                    <td style="text-align: left;">{{coti.moneda}}</td>
                                                    <td style="text-align: right;">{{ coti.monina | number:'.2-2' }}
                                                    </td>
                                                    <td style="text-align: right;">{{coti.monafe | number:'.2-2' }}</td>
                                                    <td style="text-align: right;">{{coti.monigv | number:'.2-2' }}</td>
                                                    <td style="text-align: right;">{{coti.preven | number:'.2-2' }}</td>
                                                    <!-- <td style="text-align: left;">{{ coti.vendedor }}</td> -->
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </ng-template>
                            </ngb-tab>

                            <!-- ventas -->
                            <ngb-tab *ngIf="mostrar">
                                <ng-template ngbTabTitle> <span (click)="situacFacturas()">Facturas</span></ng-template>
                                <ng-template ngbTabContent>

                                    <br>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 form-control-label">Filtrar por fecha</label>
                                        <div class="input-group col-sm-5">
                                            <label class="col-form-label m-r-5">Desde</label>
                                            <input class="form-control form-control-sm m-r-10" id="fechaDesde"
                                                name="fechaDesde" [(ngModel)]="fechaDesde" type="date" max="2999-01-01"
                                                tabindex="1">

                                            <label class="col-form-label m-r-5">Hasta</label>
                                            <input class="form-control form-control-sm" id="fechaHasta"
                                                name="fechaHasta" [(ngModel)]="fechaHasta" type="date" max="2999-01-01"
                                                tabindex="2">
                                        </div>
                                    </div>


                                    <!--TIPO DE INVENTARIO-->
                                    <div class="form-group row" style="margin-bottom: 0px;">

                                        <label for="fname2" class="col-md-2 control-label col-form-label">
                                            Sucursal:
                                        </label>


                                        <div class="col-sm-3">
                                            <select
                                                style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                tabindex="2" [(ngModel)]="_codSucursal" name="_codSucursal"
                                                class="custom-select border-consulta" class="form-control tsiInput">
                                                <option *ngFor="let lst of sessionInfo.sucursales" [value]="lst.codsuc">
                                                    {{lst.codsuc+' - '+lst.sucursal}}
                                                </option>
                                            </select>
                                        </div>

                                    </div>






                                    <div class="form-group row">

                                        <label class="col-md-2 text-left control-label col-form-label">
                                            Situación</label>

                                        <div class="col-sm-10">

                                            <div class="row">




                                                <div *ngFor="let lst of situaciones" class="col-sm-3"
                                                    style="margin-bottom: auto !important;">
                                                    <label class="ui-checkbox ui-checkbox-inline">
                                                        <input id="codSituacion" [ngModelOptions]="{standalone: true}"
                                                            (change)="onChangeSituacs(lst.situac,$event.target.checked)"
                                                            [(ngModel)]="lst.checked" value="{{lst.situac}}"
                                                            type="checkbox">
                                                        <span class="input-span"></span>{{lst.situacDesc}}
                                                    </label>
                                                </div>


                                            </div>


                                            <div class="form-group border-consulta2">
                                                <!-- <label class="form-control-label tamano-consulta">Filtrar por
                                                    situación</label> -->

                                            </div>
                                            <div class="form-row m-b-10">
                                                <label class="ui-checkbox ui-checkbox-inline"
                                                    style="padding-left: 6px; margin-top: -15px;">
                                                    <input id="select_all" (click)="CheckAllOptions()"
                                                        [(ngModel)]="check" name="check" type="checkbox"
                                                        style="margin-right: 10px;">
                                                    <span class="input-span"></span>Todos
                                                </label>
                                            </div>
                                        </div>
                                    </div>




                                    <button type="button" class="btn btn-rounded btn-info m-b-15"
                                        (click)="buscarFacturas()"><i class="fa fa-search"></i>
                                        Buscar </button>

                                    <p *ngIf="facturas != null && facturas.length > 0">Últimos 100
                                        registros
                                    </p>




                                    <div class="table-responsive" style="height:75vh;">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th class="text-center"><i class="fas fa-bullseye"></i> </th>

                                                    <th style="text-align: center; width: 100px;">#Interno</th>
                                                    <th>Documento</th>
                                                    <th style="text-align: left;">Situación</th>
                                                    <th style="text-align: left;">Estado FE</th>

                                                    <th style="text-align: left;">Serie</th>
                                                    <th style="text-align: left;">Número</th>
                                                    <th class="text-left">F.Emisión</th>
                                                    <th style="text-align: left;">Código de cliente</th>
                                                    <th style="text-align: left;">Razón Social</th>
                                                    <th style="text-align: left;">Moneda</th>
                                                    <th style="text-align: right;">Venta Inafecto</th>
                                                    <th style="text-align: right;">Venta Afecto</th>
                                                    <th style="text-align: right;">IGV</th>
                                                    <th style="text-align: right;">Precio Venta</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let coti of facturas" (click)="onClick(coti)"
                                                    [ngClass]="{'nombre-de-la-clase': coti == this.cotitemp}">

                                                    <td style="text-align: center;">

                                                        <div class="btn-group dropright" ngbDropdown container="body"
                                                            role="group" aria-label="Button group with nested dropdown"
                                                            style="margin: 0px; padding: 0px;">
                                                            <button class="btn btn-sm" ngbDropdownToggle
                                                                style="margin: 0px; padding: 0px;">
                                                                <i class=" fas fa-align-left"></i>
                                                            </button>
                                                            <div class="dropdown-menu" ngbDropdownMenu>


                                                                <button class="dropdown-item"
                                                                    (click)="trazabilidad(coti)"><i
                                                                        class="fas fa-copy font-14"
                                                                        style="margin-right: .3rem"></i>
                                                                    Trazabilidad</button>




                                                            </div>

                                                        </div>

                                                    </td>

                                                    <td style="text-align: center;">{{coti.numint}}</td>

                                                    <td>{{coti.dtipdoc}}</td>


                                                    <!-- <td style="white-space: nowrap; text-align: left;"
                                                        [ngClass]="{'classNoEnviado': coti.situacDesc === 'Anulada'}">{{coti.situacDesc}}
                                                    </td> -->

                                                    <td style="white-space: nowrap; text-align: left;"
                                                        [ngClass]="{'classNoEnviado': coti.situacDesc === 'Anulada', 'classEliminada': coti.situacDesc === 'Eliminada'}">
                                                        {{coti.situacDesc}}</td>

                                                    <td style="white-space: nowrap; text-align: left;"
                                                        [ngClass]="{'classNoEnviado': coti.estadofe === 'No enviado', 'classRechazado':coti.estadofe === 'Rechazado','classObservado':coti.estadofe === 'Observado' }">
                                                        {{coti.estadofe}}</td>

                                                    <td style="text-align: left;">{{coti.series}}</td>
                                                    <td style="text-align: left;">{{coti.numdoc}}</td>
                                                    <td style="white-space: nowrap;text-align: left;">{{coti.femisi |
                                                        date:'dd/MM/yyyy'}}
                                                    </td>
                                                    <td style="white-space: nowrap;text-align: left;">{{coti.codcli}}
                                                    </td>
                                                    <td style="white-space: nowrap;text-align: left;">{{coti.razonc}}
                                                    </td>
                                                    <td style="text-align: left;">{{coti.tipmon}}</td>
                                                    <td style="text-align: right;">{{ coti.monina | number:'.2-2' }}
                                                    </td>
                                                    <td style="text-align: right;">{{coti.monafe | number:'.2-2' }}</td>
                                                    <td style="text-align: right;">{{coti.monigv | number:'.2-2' }}</td>
                                                    <td style="text-align: right;">{{coti.preven | number:'.2-2' }}</td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>



                                </ng-template>

                            </ngb-tab>

                            <!-- ventas -->
                            <ngb-tab *ngIf="mostrar">
                                <ng-template ngbTabTitle> <span (click)="situacboletas()">Boletas</span></ng-template>
                                <ng-template ngbTabContent>

                                    <br>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 form-control-label">Filtrar por fecha</label>
                                        <div class="input-group col-sm-5">
                                            <label class="col-form-label m-r-5">Desde</label>
                                            <input class="form-control form-control-sm m-r-10" id="fechaDesde"
                                                name="fechaDesde" [(ngModel)]="fechaDesde" type="date" max="2999-01-01"
                                                tabindex="1">

                                            <label class="col-form-label m-r-5">Hasta</label>
                                            <input class="form-control form-control-sm" id="fechaHasta"
                                                name="fechaHasta" [(ngModel)]="fechaHasta" type="date" max="2999-01-01"
                                                tabindex="2">
                                        </div>
                                    </div>


                                    <!--TIPO DE INVENTARIO-->
                                    <div class="form-group row" style="margin-bottom: 0px;">

                                        <label for="fname2" class="col-md-2 control-label col-form-label">
                                            Sucursal:
                                        </label>


                                        <div class="col-sm-3">
                                            <select
                                                style="margin-bottom: 12px !important ; padding-top: 0px !important;"
                                                tabindex="2" [(ngModel)]="_codSucursal" name="_codSucursal"
                                                class="custom-select border-consulta" class="form-control tsiInput">
                                                <option *ngFor="let lst of sessionInfo.sucursales" [value]="lst.codsuc">
                                                    {{lst.codsuc+' - '+lst.sucursal}}
                                                </option>
                                            </select>
                                        </div>

                                    </div>






                                    <div class="form-group row">

                                        <label class="col-md-2 text-left control-label col-form-label">
                                            Situación</label>

                                        <div class="col-sm-10">

                                            <div class="row">




                                                <div *ngFor="let lst of situaciones" class="col-sm-3"
                                                    style="margin-bottom: auto !important;">
                                                    <label class="ui-checkbox ui-checkbox-inline">
                                                        <input id="codSituacion" [ngModelOptions]="{standalone: true}"
                                                            (change)="onChangeSituacs(lst.situac,$event.target.checked)"
                                                            [(ngModel)]="lst.checked" value="{{lst.situac}}"
                                                            type="checkbox">
                                                        <span class="input-span"></span> {{lst.situacDesc}}
                                                    </label>
                                                </div>


                                            </div>


                                            <div class="form-group border-consulta2">
                                                <!-- <label class="form-control-label tamano-consulta">Filtrar por
                        situación</label> -->

                                            </div>
                                            <div class="form-row m-b-10">
                                                <label class="ui-checkbox ui-checkbox-inline"
                                                    style="padding-left: 6px; margin-top: -15px;">
                                                    <input id="select_all" (click)="CheckAllOptions()"
                                                        [(ngModel)]="check" name="check" type="checkbox"
                                                        style="margin-right: 10px;">
                                                    <span class="input-span"></span>Todos
                                                </label>
                                            </div>
                                        </div>
                                    </div>




                                    <button type="button" class="btn btn-rounded btn-info m-b-15"
                                        (click)="buscarBoletas()"><i class="fa fa-search"></i>
                                        Buscar </button>

                                    <p *ngIf="boletas != null && boletas.length > 0">Últimos 100
                                        registros
                                    </p>




                                    <div class="table-responsive" style="height:75vh;">
                                        <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                            <thead>
                                                <tr>
                                                    <th class="text-center"><i class="fas fa-bullseye"></i> </th>

                                                    <th style="text-align: center; width: 100px;">#Interno</th>
                                                    <th>Documento</th>
                                                    <th style="text-align: left;">Situación</th>
                                                    <th style="text-align: left;">Estado FE</th>

                                                    <th style="text-align: left;">Serie</th>
                                                    <th style="text-align: left;">Número</th>
                                                    <th class="text-left">F.Emisión</th>
                                                    <th style="text-align: left;">Cliente</th>
                                                    <th style="text-align: left;">Razón Social</th>
                                                    <th style="text-align: left;">Moneda</th>
                                                    <th style="text-align: right;">Venta Inafecto</th>
                                                    <th style="text-align: right;">Venta Afecto</th>
                                                    <th style="text-align: right;">IGV</th>
                                                    <th style="text-align: right;">Precio Venta</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let coti of boletas" (click)="onClick(coti)"
                                                    [ngClass]="{'nombre-de-la-clase': coti == this.cotitemp}">

                                                    <td style="text-align: center;">

                                                        <div class="btn-group dropright" ngbDropdown container="body"
                                                            role="group" aria-label="Button group with nested dropdown"
                                                            style="margin: 0px; padding: 0px;">
                                                            <button class="btn btn-sm" ngbDropdownToggle
                                                                style="margin: 0px; padding: 0px;">
                                                                <i class=" fas fa-align-left"></i>
                                                            </button>
                                                            <div class="dropdown-menu" ngbDropdownMenu>



                                                                <button class="dropdown-item"
                                                                    (click)="trazabilidad(coti)"><i
                                                                        class="fas fa-copy font-14"
                                                                        style="margin-right: .3rem"></i>
                                                                    Trazabilidad</button>


                                                            </div>

                                                        </div>

                                                    </td>

                                                    <td style="text-align: center;">{{coti.numint}}</td>

                                                    <td>{{coti.dtipdoc}}</td>


                                                    <!-- <td style="white-space: nowrap; text-align: left;"
                            [ngClass]="{'classNoEnviado': coti.situacDesc === 'Anulada'}">{{coti.situacDesc}}
                        </td> -->

                                                    <td style="white-space: nowrap; text-align: left;"
                                                        [ngClass]="{'classNoEnviado': coti.situacDesc === 'Anulada', 'classEliminada': coti.situacDesc === 'Eliminada'}">
                                                        {{coti.situacDesc}}</td>

                                                    <td style="white-space: nowrap; text-align: left;"
                                                        [ngClass]="{'classNoEnviado': coti.estadofe === 'No enviado', 'classRechazado':coti.estadofe === 'Rechazado','classObservado':coti.estadofe === 'Observado' }">
                                                        {{coti.estadofe}}</td>

                                                    <td style="text-align: left;">{{coti.series}}</td>
                                                    <td style="text-align: left;">{{coti.numdoc}}</td>
                                                    <td style="white-space: nowrap;text-align: left;">{{coti.femisi |
                                                        date:'dd/MM/yyyy'}}
                                                    </td>
                                                    <td style="white-space: nowrap;text-align: left;">{{coti.codcli}}
                                                    </td>
                                                    <td style="white-space: nowrap;text-align: left;">{{coti.razonc}}
                                                    </td>
                                                    <td style="text-align: left;">{{coti.tipmon}}</td>
                                                    <td style="text-align: right;">{{ coti.monina | number:'.2-2' }}
                                                    </td>
                                                    <td style="text-align: right;">{{coti.monafe | number:'.2-2' }}</td>
                                                    <td style="text-align: right;">{{coti.monigv | number:'.2-2' }}</td>
                                                    <td style="text-align: right;">{{coti.preven | number:'.2-2' }}</td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>



                                </ng-template>

                            </ngb-tab>
                           <!--Guias de remision-->
                           <ngb-tab *ngIf=mostrar>
                            <ng-template ngbTabTitle> <span>Guías de remisión</span></ng-template>
                            <ng-template ngbTabContent>


                                <br>

                               
                                    <div class="row">
                                        
                                      <div class="col-md-2">
                                        <div class="form-group border-consulta2">
                                            <label class="form-control-label tamano-consulta">Filtrar por situación</label>
                                            <div  *ngFor="let lst of situaciones2" class="m-b-10 "
                                                style="margin-bottom: auto !important;">
                                                <div class="row">
                                                    <label class="ui-checkbox ui-checkbox-inline">
                                                        <input id="codSituacion" [ngModelOptions]="{standalone: true}"
                                                        (change)="onChange2(lst.situac,$event.target.checked)"
                                                        [(ngModel)]="lst.checked" value="{{lst.situac}}"
                                                            type="checkbox"
                                                            style="margin-right: 10px;">
                                                        <span class="input-span"></span>{{lst.situacDesc}}
                                                    </label>
                                                </div>      
                                            </div>
                                            <div class="row">      
                                                <label class="ui-checkbox ui-checkbox-inline">
                                                    <input id="select_all" 
                                                    (click)="CheckAllOptions2()" [(ngModel)]="check2"
                                                        name="check" type="checkbox" style="margin-right: 10px;">
                                                    <span class="input-span"></span>Todos
                                                </label>
                                            </div>
                                        </div>
                                      </div>

                                      <div class="col-md-9">
                                        <div class="form-row">
                                            <div class="col-md-6">
                                                <div class="form-group border-consulta">
                                                    <label class="form-control-label tamano-consulta">Filtrar por fecha</label>
                                                    <div class="input-group">
                                                        <label class="col-form-label-sm m-r-5">Desde</label>
                                                        <input class="form-control form-control-sm m-r-10" id="fechaDesde"
                                                            name="fechaDesde"
                                                            [(ngModel)]="fechaDesde"
                                                            type="date"
                                                            max="2999-01-01" tabindex="1" style="text-align: center !important;"
                                                            #fechaDesdeInput>
        
                                                        <label class="col-form-label-sm m-r-5">Hasta</label>
                                                        <input class="form-control form-control-sm" id="fechaHasta"
                                                            name="fechaHasta"
                                                            [(ngModel)]="fechaHasta"  type="date"
                                                            max="2999-01-01" tabindex="2"
                                                            style="text-align: center !important;">
                                                    </div>
                                                </div>
                                                <div class="form-group border-consulta">
                                                    <label class="form-control-label tamano-consulta">Filtrar por
                                                        vendedor</label>
                                                    <div class="input-group">
                                                        <input class="form-control form-control-sm m-r-5 col-md-2"
                                                            id="codVendedor" name="codVendedor" 
                                                            [(ngModel)]="codVendedor"
                                                    (keydown.enter)="onKeyEnterVendedor($event)"
                                                    (blur)="onBlurVendedor($event)" type="text" tabindex="3"
                                                            style="text-align: center !important;">
                                                        <select class="form-control form-control-sm" id="cboVendedor"
                                                            name="codVendedor"
                                                            [(ngModel)]="codVendedor"  tabindex="4">
                                                            <option value="-1">Todos</option>
                                                            <option *ngFor="let lst of vendedores" value="{{lst.codven}}">
                                                                {{lst.descven}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                              <div class="form-group border-consulta">
                                                    <label class="form-control-label tamano-consulta">Filtrar por
                                                        sucursal</label>
                                                    <div class="input-group">
                                                        <input class="form-control form-control-sm m-r-5 col-md-2"
                                                            id="codSucursal" name="codSucursal" 
                                                            [(ngModel)]="codSucursal"
                                                    (keydown.enter)="onKeyEnterSucursal($event)"
                                                    (blur)="onBlurSucursal($event)"
                                                            type="text" tabindex="5"
                                                            style="text-align: center !important;">
                                                        <select class="form-control form-control-sm" id="cboSucursal"
                                                            name="codSucursal"
                                                            [(ngModel)]="codSucursal"
                                                            tabindex="6">
                                                            <option value="-1">Todos</option>
                                                            <option *ngFor="let lst of sucursales" value="{{lst.codsuc}}">
                                                                {{lst.sucursal}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6" style="padding-left: 30px;">
        
                                                <!--Filtro Por Motivo-->
                                                <div class="form-group border-consulta">
                                                    <label class="form-control-label tamano-consulta">Filtrar por motivo</label>
                                                    <div class="input-group">
                                                        <input class="form-control form-control-sm m-r-5 col-md-2"
                                                            id="codMotivo" name="codMotivo" 
                                                            [(ngModel)]="codMotivo"
                                                    (keydown.enter)="onKeyEnterMotivo($event)"
                                                    (blur)="onBlurMotivo($event)"
                                                            type="text" tabindex="10"
                                                            style="text-align: center !important;">
                                                        <select class="form-control form-control-sm" id="cboMotivo"
                                                            name="codMotivo"
                                                            [(ngModel)]="codMotivo" 
                                                            tabindex="11">
                                                            <option value="-1">Todos</option>
                                                            <option *ngFor="let lst of motivos" value="{{lst.codmot}}">
                                                                {{lst.desmot}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="form-group border-consulta">
                                                    <label class="form-control-label tamano-consulta">Filtrar por estado de
                                                        envío a
                                                        SUNAT</label>
                                                    <div class="input-group">
                                                        <input class="form-control form-control-sm m-r-5 col-md-2" id="codSunat"
                                                            name="codSunat" 
                                                            [(ngModel)]="codSunat"
                                                    (keydown.enter)="onKeyEnterSunat($event)"
                                                    (blur)="onBlurSunat($event)"
                                                    type="text" tabindex="12"
                                                            style="text-align: center !important;">
                                                        <select class="form-control form-control-sm" id="cboSunat"
                                                            name="codSunat" 
                                                            [(ngModel)]="codSunat"
                                                            tabindex="13">
                                                            <option value="-1">Todos</option>
                                                            <option *ngFor="let lst of sunatlist" value="{{lst.codest}}">
                                                                {{lst.descri}}
                                                            </option>
                                                        </select>
        
                                                    </div>
                                                </div>
        
                                            </div>
                                           <!--  <div class="col-md-12">
                                                <div class="form-group border-consulta">
                                                    <label class="form-control-label tamano-consulta">Filtrar por interlocutor
                                                        comercial</label>
                                                    <div class="input-group">
                                                        <input id="inputinterlocutorcodigo" type="text"
                                                            class="form-control col-md-3 form-control-sm mr-2"
                                                            name="desInterlocutor" 
                                                            #interlocutor placeholder="-1"
                                                            style="text-align: center !important;" disabled>
                                                        <input id="inputinterlocutornombre" type="text"
                                                            class="form-control form-control-sm" name="codInterlocutor"
                                                            
                                                            placeholder="Todos" disabled>
        
                                                        <button 
                                                            class="btn btn-primary btn-sm  m-b-5"
                                                             type="button" tabindex="9" disabled><i
                                                                class="fa fa-search"></i></button>
                                                        <button *ngIf="buscarInterlocutor == 'borrar'"
                                                            class="btn btn-primary btn-sm  m-b-5"
                                                            type="button" tabindex="9"><i
                                                                class="fas fa-times"></i></button>
        
                                                    </div>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                
                                    </div>
                                 

                                <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="consultar()"><i class="fa fa-search"></i>
                                        Buscar 
                                </button>

                                <br>
                                <!-- <p *ngIf="sp_ventas != null && sp_ventas.length > 0">Últimos 100 registros</p> -->
                                <div class="table-responsive" style="height: 400px;">
                                    <table class="table table-sm table-striped table-bordered m-t-15 table-hover">
                                        <thead>
                                            <tr>
                                                <th class="text-center"><i class="fas fa-bullseye"></i> </th>
                                                <th style="text-align: center; width: 100px;">#Interno</th>
                                                <th style="text-align: left;">Situación</th>
                                                <th style="text-align: left;">N° Adjuntos</th>
                                                <th> Estado F.E </th>
                                                <th style="text-align: left;">Serie</th>
                                                <th style="text-align: left;">Número</th>
                                                <th style="text-align: left;">F. Emisión</th>
                                                <th style="text-align: left;">Razón Social</th>
                                                <th style="text-align: left;">Moneda</th>
                                                <th style="text-align: right;">Venta Inafecto</th>
                                                <th style="text-align: right;">Venta Afecto</th>
                                                <th style="text-align: right;">IGV</th>
                                                <th style="text-align: right;">Precio Venta</th>
                                                <th style="white-space: nowrap; text-align: left;">F. Creación</th>
                                                <th style="white-space: nowrap; text-align: left;">F. Actualización</th>
                                                <th style="white-space: nowrap; text-align: left;">Creado por</th>
                                                <th style="white-space: nowrap; text-align: left;">Actualizado por</th>
                                                


                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let coti of cotizaciones">


                                                <td>

                                                    <div class="btn-group dropright" ngbDropdown container="body" role="group" aria-label="Button group with nested dropdown" style="margin: 0px; padding: 0px;">
                                                        <button class="btn btn-sm" ngbDropdownToggle style="margin: 0px; padding: 0px;">
                                                            <i class=" fas fa-align-left"></i>
                                                        </button>
                                                        <div class="dropdown-menu" ngbDropdownMenu>
                                                            <button class="dropdown-item" (click)="imprimir(coti)"><i
                                                                    class="fa fa-print font-14" style="margin-right: .3rem"></i>
                                                                Imprimir A4
                                                            </button>
                
                                                            <button *ngIf="(coti.situac != 'J' && coti.situac != 'C')"
                                                                class="dropdown-item" (click)="anular(coti)"><i class="fas fa-ban"
                                                                    style="margin-right: .3rem"></i> Anular</button>
                
                                                            <button *ngIf="(coti.situac == 'J' && coti.situacfe == 0)" class="dropdown-item"
                                                                (click)="eliminar(coti)"><i class="fas fa-ban"
                                                                    style="margin-right: .3rem"></i> Eliminar</button>
                
                
                                                            <button *ngIf="(coti.situac == 'F' && coti.situacfe != 1)"
                                                                class="dropdown-item" (click)="sendSunat(coti)"><i
                                                                    class=" fas fa-location-arrow font-14"
                                                                    style="margin-right: .3rem"></i>
                                                                Enviar a SUNAT</button>
                
                                                            <button *ngIf="(coti.situacfe == 1)" class="dropdown-item"
                                                                (click)="download_xml(coti)"><i class="fa fas fa-download font-14"
                                                                    style="margin-right: .3rem"></i>
                                                                Descargar XML</button>
                
                                                            <button *ngIf="(coti.situacfe == 1)" class="dropdown-item"
                                                                (click)="download_cdr(coti)"><i class="fa fas fa-download font-14"
                                                                    style="margin-right: .3rem"></i>
                                                                Descargar CDR</button>
                
                
                                                            <button class="dropdown-item" (click)="trazabilidad(coti)"><i
                                                                    class="fas fa-copy font-14" style="margin-right: .3rem"></i>
                                                                Trazabilidad</button>
                
                                                            <li>
                                                                <a class="dropdown-item" href="javascript:;"
                                                                    (click)="documentos_adjuntos(coti)"><i class="fas fa-copy font-14"
                                                                        style="margin-right: .3rem"></i>Documentos adjuntos</a>
                                                            </li>
                                                            <button class="dropdown-item" (click)="openModalDocumento(coti)"><i
                                                                class="fa fa-plus font-14" style="margin-right: .3rem"></i>
                                                             Detalle documento  
                                                            </button>
                                                        </div>
                                                    </div>
                                                </td>


                                                <td style="text-align: center;">{{coti.numint}}</td>
                                                <td style="white-space: nowrap;text-align: left;">{{coti.situacDesc}}</td>
                                                <td style="white-space: nowrap; text-align: left;">{{coti.countadj}}</td>
                                                <td style="white-space: nowrap;"> {{coti.estadofe}} </td>
                                                <td style="text-align: left;">{{coti.series}}</td>
                                                <td style="text-align: left;">{{coti.numdoc}}</td>
                                                <td style="white-space: nowrap;text-align: left;">{{coti.femisi | date:'dd/MM/yyyy'}}
                                                </td>
                                                <td style="white-space: nowrap;text-align: left;">{{coti.razonc}}</td>
                                                <td style="text-align: left;">{{coti.tipmon}}</td>
                                                <td style="text-align: right;">{{ coti.monina | number:'.2-2' }}</td>
                                                <td style="text-align: right;">{{coti.monafe | number:'.2-2' }}</td>
                                                <td style="text-align: right;">{{coti.monigv | number:'.2-2' }}</td>
                                                <td style="text-align: right;">{{coti.preven | number:'.2-2' }}</td>
                                                <td style="white-space: nowrap;">{{coti.fcreac | date:'dd/MM/yyyy'}}</td>
                                                <td style="white-space: nowrap;">{{coti.factua | date:'dd/MM/yyyy'}}</td>
                                                <td style="white-space: nowrap;">{{coti.ucreac}}</td>
                                                <td style="white-space: nowrap;">{{coti.usuari}}</td>



                                            </tr>
                                        </tbody>
                                    </table>
                                </div>  



                            </ng-template>

                        </ngb-tab>

                        </ngb-tabset>

                        <!-- -->
                        <ng-template #content1 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Nueva clase:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Clase:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            [(ngModel)]="codClase" name="codClase" type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select tabindex="15" class="custom-select"
                                                            [(ngModel)]="codClase"
                                                            (change)="onChangeClases($event.target.value)"
                                                            name="codClase" #selectClase>
                                                            <option *ngFor="let claseSele of listaclases"
                                                                value="{{claseSele.codigo}}">
                                                                {{claseSele.codigo+' - '+claseSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Código:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            [(ngModel)]="codCodigoClase" name="codCodigoClase"
                                                            type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3">
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select [disabled]="disabledCodigosClaseCombo" tabindex="15"
                                                            class="custom-select" [(ngModel)]="codCodigoClase"
                                                            name="codCodigoClase" #selectClase>
                                                            <option *ngFor="let codigoSele of listacodigos"
                                                                value="{{codigoSele.codigo}}">
                                                                {{codigoSele.codigo+' - '+codigoSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <!-- <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="guardarClase();" tabindex="5"><i
                    class="fa fa-save"></i>Guardar</button>
                    -->
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="guardarClase()" tabindex="5">
                                    <i class=" fas fa-angle-double-right"></i> Continuar </button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>






                            </div>
                        </ng-template>
                        <!-- Modifica Clase-->
                        <ng-template #content2 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar Clase:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Clase:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            [(ngModel)]="editinputcla" name="editinputcla" type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select disabled tabindex="15" class="custom-select"
                                                            [(ngModel)]="editinputcla" name="editinputcla" #selectClase>
                                                            <option *ngFor="let claseSele of listaclases"
                                                                value="{{claseSele.codigo}}">
                                                                {{claseSele.codigo+' - '+claseSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Código:</label>
                                                    <div class="col-md-2">
                                                        <input disabled style="text-align: center;" class="form-control"
                                                            [(ngModel)]="editinputcodigo" name="editinputcodigo"
                                                            type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3">
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select tabindex="15" class="custom-select"
                                                            [(ngModel)]="editinputcodigo" name="editinputcodigo"
                                                            #selectClase>
                                                            <option *ngFor="let codigoSele of listacodigos"
                                                                value="{{codigoSele.codigo}}">
                                                                {{codigoSele.codigo+' - '+codigoSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success"
                                    (click)="guardarActualizarClase();" tabindex="5"><i
                                        class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Nueva Condicion de Pago-->
                        <ng-template #content3 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Nueva condición de pago:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->

                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Cond.
                                                        pago:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            [(ngModel)]="codCondicionPago" name="codCondicionPago"
                                                            type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select tabindex="15" class="custom-select select_border"
                                                            [(ngModel)]="codCondicionPago" name="codCondicionPago"
                                                            #selectClase style="color: black;">
                                                            <option *ngFor="let claseSele of listacondpago"
                                                                value="{{claseSele.codpag}}">
                                                                {{claseSele.codpag+' - '+claseSele.despag}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>

                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <label for="fname2"
                                                        style="padding: 0.2em 0em 0em .5em; margin-right: 10px !important;"
                                                        class=" col-md-4 control-label col-form-label"></label>

                                                    <label class="ui-checkbox" style="margin-right: 10px !important;">
                                                        <input type="checkbox"
                                                            (change)="onChangePredeterminado($event.target.checked)"
                                                            [checked]="predeterminado" id="predeterminado"
                                                            tabindex="302">
                                                        <span class="input-span"></span>
                                                    </label>
                                                    <label style="margin-right: .5rem"
                                                        for="predeterminado">Predeterminado</label>


                                                    <label class="ui-checkbox">
                                                        <input type="checkbox"
                                                            (change)="onChangeActivo($event.target.checked)" id="activo"
                                                            [checked]="activo" tabindex="303">
                                                        <span class="input-span"></span>
                                                    </label>
                                                    <label style="margin-right: .5rem; margin-left: .5rem"
                                                        for="activo">Activo</label>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success" (click)="nuevaCondicionPago()"
                                    tabindex="5"><i class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Modificar Condicion de Pago-->
                        <ng-template #content4 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar condición de pago:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->

                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Cond.
                                                        pago:</label>
                                                    <div class="col-md-2">
                                                        <input disabled style="text-align: center;" class="form-control"
                                                            [(ngModel)]="codCondicionPagoUpd" name="codCondicionPagoUpd"
                                                            type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select disabled tabindex="15"
                                                            class="custom-select select_border" style="color: black;"
                                                            [(ngModel)]="codCondicionPagoUpd"
                                                            name="codCondicionPagoUpd   " #selectClase>
                                                            <option *ngFor="let claseSele of listacondpago"
                                                                value="{{claseSele.codpag}}">
                                                                {{claseSele.codpag+' - '+claseSele.despag}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>

                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <label for="fname2"
                                                        style="padding: 0.2em 0em 0em .5em; margin-right: 10px !important;"
                                                        class=" col-md-4 control-label col-form-label"></label>

                                                    <label class="ui-checkbox" style="margin-right: 10px !important;">
                                                        <input type="checkbox"
                                                            (change)="onChangePredeterminadoUpd($event.target.checked)"
                                                            [checked]="predeterminadoUpd" id="predeterminadoUpd"
                                                            tabindex="302">
                                                        <span class="input-span"></span>
                                                    </label>
                                                    <label style="margin-right: .5rem"
                                                        for="predeterminadoUpd">Predeterminado</label>


                                                    <label class="ui-checkbox">
                                                        <input type="checkbox"
                                                            (change)="onChangeActivoUpd($event.target.checked)"
                                                            [checked]="activoUpd" id="activoUpd" tabindex="303">
                                                        <span class="input-span"></span>
                                                    </label>
                                                    <label style="margin-right: .5rem; margin-left: .5rem"
                                                        for="activoUpd">Activo</label>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success"
                                    (click)="guardarActualizarCondicion()" tabindex="5"><i
                                        class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Nuevo Contacto-->


                        <!-- Nueva Especificación-->
                        <ng-template #content7 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Nueva Especificación:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>
                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div *ngIf="tipoConfirmar == 'Insert'" class="modal-body" id="first">
                                                    <h5 class="modal-title pull-left">Visualización de especificaciones
                                                    </h5>
                                                    <div class="form-row col-md-12">
                                                        <table
                                                            class="table table-striped display nowrap dataTable no-footer"
                                                            id="datatableEspecificaciones" cellspacing="0" width="100%">
                                                            <thead>
                                                                <tr>
                                                                    <th>Código</th>
                                                                    <th>Especificación</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr *ngFor="let lst of especificacion"
                                                                    (click)="onCLickEspecificacion(lst)">
                                                                    <td>{{lst.codigo}}</td>
                                                                    <td>{{lst.descri}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div *ngIf="tipoConfirmar == 'InsertEspecificacion'" class="modal-body"
                                                    id="first">
                                                    <form action="" #form="ngForm" autocomplete="off">
                                                        <div *ngIf="disabledDecimal == true" class="input-group">
                                                            <label style="margin-right: .6em">Decimal</label>
                                                            <input class="col-md-3 form-control form-control-sm m-r-5"
                                                                id="decimal" name="decimal" [(ngModel)]="decimal"
                                                                type="number" maxlength="5" style="margin-right: .5rem"
                                                                onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                        </div>

                                                        <div *ngIf="disabledTexto == true" class="input-group">
                                                            <label style="margin-right: 1.8rem">Texto</label>
                                                            <input class="form-control form-control-sm" id="texto"
                                                                name="texto" [(ngModel)]="texto" type="text"
                                                                style="text-transform:uppercase;">
                                                        </div>

                                                        <div *ngIf="disabledCaracter == true" class="input-group">
                                                            <label style="margin-right: .5rem">Caracter</label>
                                                            <input class="form-control form-control-sm col-md-2"
                                                                id="caracter" name="caracter" [(ngModel)]="caracter"
                                                                type="text" style="text-transform:uppercase;">
                                                        </div>

                                                        <div *ngIf="disabledFecha == true" class="input-group">
                                                            <label style="margin-right: 1.75rem">Fecha</label>
                                                            <input class="form-control form-control-sm col-md-4"
                                                                id="fecha" name="fecha" [(ngModel)]="fecha" type="date"
                                                                max="2999-01-01">
                                                        </div>

                                                        <div *ngIf="disabledTiempo == true" class="input-group">
                                                            <label style="margin-right: 1rem">Tiempo</label>
                                                            <input class="form-control form-control-sm col-md-2"
                                                                id="tiempo" name="tiempo" [(ngModel)]="tiempo"
                                                                type="time" style="text-transform:uppercase;">
                                                        </div>

                                                        <div *ngIf="disabledNumero == true" class="input-group">
                                                            <label style="margin-right: .7rem">Número</label>
                                                            <input class="form-control form-control-sm col-md-2"
                                                                id="numero" name="numero" [(ngModel)]="numero"
                                                                type="text" style="text-transform:uppercase;">
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="guardarEspecificacion();" tabindex="5"><i
                                        class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Modificar Especificación -->
                        <ng-template #content8 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar Especificación:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h5 class="modal-title pull-left"></h5>
                                                <div class="form-row col-md-12">
                                                    <table
                                                        class="table table-striped display nowrap dataTable no-footer"
                                                        id="datatableEspecificaciones" cellspacing="0" width="100%">
                                                        <thead>
                                                            <tr>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <div>
                                                                <h5 class="modal-title pull-left">
                                                                    {{desEspecificacionUpd}}
                                                                </h5>
                                                                <br>
                                                            </div>
                                                            <div>
                                                                <form action="" #form="ngForm" autocomplete="off">
                                                                    <div *ngIf="disabledDecimalUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: .6em">Decimal</label>
                                                                        <input
                                                                            class="col-md-3 form-control form-control-sm m-r-5"
                                                                            id="decimalUpd" name="decimalUpd"
                                                                            [(ngModel)]="decimalUpd" maxlength="5"
                                                                            type="text" style="margin-right: .5rem"
                                                                            onkeypress='return event.charCode >= 8 && event.charCode <= 57'>
                                                                    </div>

                                                                    <div *ngIf="disabledTextoUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: 1.8rem">Texto</label>
                                                                        <input class="form-control form-control-sm"
                                                                            id="textoUpd" name="textoUpd"
                                                                            [(ngModel)]="textoUpd" type="text"
                                                                            style="text-transform:uppercase;">
                                                                    </div>

                                                                    <div *ngIf="disabledCaracterUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: .5rem">Caracter</label>
                                                                        <input
                                                                            class="form-control form-control-sm col-md-2"
                                                                            id="caracterUpd" name="caracterUpd"
                                                                            [(ngModel)]="caracterUpd" type="text"
                                                                            style="text-transform:uppercase;">
                                                                    </div>

                                                                    <div *ngIf="disabledFechaUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: 1.75rem">Fecha</label>
                                                                        <input
                                                                            class="form-control form-control-sm col-md-4"
                                                                            id="fechaUpd" name="fechaUpd"
                                                                            [(ngModel)]="fechaUpd" type="date"
                                                                            max="2999-01-01">
                                                                    </div>

                                                                    <div *ngIf="disabledTiempoUpd == true"
                                                                        class="input-group">
                                                                        <label style="margin-right: 1rem">Tiempo</label>
                                                                        <input
                                                                            class="form-control form-control-sm col-md-2"
                                                                            id="tiempoUpd" name="tiempoUpd"
                                                                            [(ngModel)]="tiempoUpd" type="time"
                                                                            style="text-transform:uppercase;">
                                                                    </div>

                                                                    <div *ngIf="disabledNumeroUpd == true"
                                                                        class="input-group">
                                                                        <label
                                                                            style="margin-right: .7rem">Número</label>
                                                                        <input
                                                                            class="form-control form-control-sm col-md-2"
                                                                            id="numeroUpd" name="numeroUpd"
                                                                            [(ngModel)]="numeroUpd" type="text"
                                                                            style="text-transform:uppercase;">
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="ModificarEspecificacion();" tabindex="5"><i
                                        class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!-- Nueva Direccion de Envío-->

                        <ng-template #NuevaClase let-modal>
                            <div class="modal-header">
                                <h4>Nueva clase </h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form>

                                    <div class="form-group">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Clase:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            name="codClase" type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3" disabled>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select tabindex="15" class="custom-select" name="codClase"
                                                            #selectClase>
                                                            <!-- <option *ngFor="let claseSele of listaclases" value="{{claseSele.codigo}}">
                                {{claseSele.codigo+' - '+claseSele.descri}}
                                </option> -->
                                                            <option value="1">
                                                                Opcion01
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                                <div class="form-group row" style="margin-bottom: 0.5rem;">
                                                    <!---->
                                                    <label for="fname2" style="padding: 0.2em 0em 0em .5em;"
                                                        class=" col-md-2 control-label col-form-label">Código:</label>
                                                    <div class="col-md-2">
                                                        <input style="text-align: center;" class="form-control"
                                                            name="codCodigoClase" type="text"
                                                            onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                            maxlength="3">
                                                    </div>
                                                    <div class="col-md-7">
                                                        <select [disabled]="disabledCodigosClaseCombo" tabindex="15"
                                                            class="custom-select" name="codCodigoClase" #selectClase>
                                                            <option *ngFor="let codigoSele of listacodigos"
                                                                value="{{codigoSele.codigo}}">
                                                                {{codigoSele.codigo+' - '+codigoSele.descri}}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <span style="color: red; font: sans-serif;">(*)</span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success" tabindex="5">
                                    <i class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>


                        <!-- Modificar Direccion de Envío -->
                        <ng-template #content10 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar dirección de envío:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form action="" #form="ngForm" autocomplete="off">

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Código</label>
                                        <div class="col-sm-3">
                                            <input class="form-control form-control-sm m-r-5" id="codEnvioUpd"
                                                name="codEnvioUpd" [(ngModel)]="codEnvioUpd" type="text" disabled>
                                        </div>


                                        <div style="margin-left: 15px;">
                                            <label class="ui-checkbox">
                                                <input type="checkbox" id="activoDirecEnvio"
                                                    [checked]="activoDirecEnvio"
                                                    (change)="onChangeactivoDirecEnvio($event.target.checked)"
                                                    tabindex="604">
                                                <span class="input-span"></span>
                                            </label> <label class="tsiLabel form-check-label"
                                                for="activoDirecEnvio">Activo</label>
                                        </div>

                                    </div>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label
                                            class="col-md-2 text-left control-label col-form-label">Descripción</label>
                                        <div class="col-sm-7">
                                            <input class="form-control form-control-sm" id="desEnvioUpd"
                                                name="desEnvioUpd" [(ngModel)]="desEnvioUpd" maxlength="50" type="text"
                                                tabindex="801">
                                        </div>
                                        <span style="color: red; font: sans-serif;">(*)</span>
                                    </div>


                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Dirección</label>
                                        <div class="col-sm-9">
                                            <input class="form-control form-control-sm" id="direccionE1Upd"
                                                name="direccionE1Upd" [(ngModel)]="direccionE1Upd" maxlength="120"
                                                type="text" tabindex="802">
                                        </div>

                                        <span style="color: red; font: sans-serif;">(*)</span>
                                    </div>


                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label
                                            class="col-md-2 text-left control-label col-form-label">Referencia</label>
                                        <div class="col-sm-4">
                                            <input class="form-control form-control-sm m-r-5" id="referenciaEnvioUpd"
                                                name="referenciaEnvioUpd" [(ngModel)]="referenciaEnvioUpd"
                                                maxlength="50" type="text" tabindex="803">
                                        </div>
                                    </div>



                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Código
                                            EAN</label>
                                        <div class="col-sm-4">
                                            <input class="form-control form-control-sm m-r-5" id="codEanEnvioUpd"
                                                name="codEanEnvioUpd" [(ngModel)]="codEanEnvioUpd" maxlength="30"
                                                type="text" tabindex="805">
                                        </div>
                                    </div>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Teléfono</label>
                                        <div class="col-sm-4">
                                            <input class="form-control form-control-sm" id="telefonoEnvioUpd"
                                                name="telefonoEnvioUpd" [(ngModel)]="telefonoEnvioUpd" maxlength="30"
                                                type="text" tabindex="804">
                                        </div>
                                    </div>

                                    <div class="form-group row" style="margin-bottom: 0px;">
                                        <label class="col-md-2 text-left control-label col-form-label">Celular</label>
                                        <div class="col-sm-4">
                                            <input class="form-control form-control-sm" id="celularEnvioUpd"
                                                name="celularEnvioUpd" [(ngModel)]="celularEnvioUpd" maxlength="30"
                                                type="text" tabindex="806">
                                        </div>
                                    </div>




                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success"
                                    (click)="ModificarDireccionEnvio();" tabindex="5"><i
                                        class=" fas fa-angle-double-right m-b-15"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!--Nuevo Banco-->
                        <ng-template #content11 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Nuevo banco:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form action="" #form="ngForm" autocomplete="off">
                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="input-group" style="margin-bottom: 0.5rem;">
                                                <label style="margin-right: .5rem">Financiera</label>
                                                <input class="col-md-2 form-control form-control-sm m-r-5" id="codBanco"
                                                    name="codBanco" [(ngModel)]="codBanco" type="number"
                                                    style="margin-right: .5rem" maxlength="3"
                                                    style="text-transform:uppercase;" tabindex="1000">

                                                <select class="form-control form-control-sm" id="cboBanco"
                                                    name="codBanco" [(ngModel)]="codBanco"
                                                    (change)="onChangeFinanciera($event.target.value)" tabindex="1001">
                                                    <option *ngFor="let cc of financieras" value="{{cc.codigo}}">
                                                        {{cc.codigo}} - {{cc.descri}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="input-group" style="margin-bottom: 0.5rem;">
                                                <label style="margin-right: .5rem">Tipo cuenta</label>
                                                <input class="col-md-2 form-control form-control-sm m-r-5"
                                                    id="codTipoCuenta" name="codTipoCuenta" [(ngModel)]="codTipoCuenta"
                                                    type="text" style="margin-right: .5rem" maxlength="2"
                                                    style="text-transform:uppercase;" tabindex="1002">

                                                <select class="form-control form-control-sm" id="cboTipoCuenta"
                                                    name="codTipoCuenta" [(ngModel)]="codTipoCuenta"
                                                    (change)="onChangeTipoCuenta()" [disabled]="disabledTipoCuenta"
                                                    tabindex="1003">
                                                    <option *ngFor="let ccc of tipocuentas" value="{{ccc.codigo}}">
                                                        {{ccc.descri}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="input-group" style="margin-bottom: 0.5rem;">
                                                <label style="margin-right: 1.5rem">Moneda</label>
                                                <input class="form-control form-control-sm col-md-2 m-r-5"
                                                    id="codMoneda" name="codMoneda" [(ngModel)]="codMoneda" type="text"
                                                    tabindex="1004" maxlength="3">
                                                <select class="form-control form-control-sm" id="cboMoneda"
                                                    name="codMoneda" tabindex="1005" [(ngModel)]="codMoneda"
                                                    [disabled]="disabledMoneda">
                                                    <option *ngFor="let mon of monedas" value="{{mon.codmon}}">
                                                        {{mon.desmon}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group" style="margin-bottom: 0.5rem;">
                                                <label style="margin-right: 1.35rem">N° cuenta</label>
                                                <input class="form-control form-control-sm" id="desCuenta"
                                                    name="desCuenta" tabindex="1006" [(ngModel)]="desCuenta" type="text"
                                                    style="margin-right: .5rem" maxlength="100"
                                                    style="text-transform:uppercase;">
                                            </div>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="guardarBanco();" tabindex="5">
                                    <i class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>
                        <!--Modificar Banco-->
                        <ng-template #content12 let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title" id="modal-basic-title">Modificar Banco:</h4>
                                <button type="button" class="close" aria-label="Close"
                                    (click)="modal.dismiss('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <form action="" #form="ngForm" autocomplete="off">
                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="input-group" style="margin-bottom: 0.5rem;">
                                                <label style="margin-right: .5rem">Financiera</label>
                                                <input disabled class="col-md-2 form-control form-control-sm m-r-5"
                                                    id="codBancoUpd" name="codBancoUpd" [(ngModel)]="codBancoUpd"
                                                    type="number" style="margin-right: .5rem" maxlength="3"
                                                    style="text-transform:uppercase;" tabindex="1000">

                                                <select disabled class="form-control form-control-sm" id="cboBanco"
                                                    name="codBancoUpd" [(ngModel)]="codBancoUpd"
                                                    (change)="onChangeFinanciera($event.target.value)" tabindex="1001">
                                                    <option *ngFor="let cc of financieras" value="{{cc.codigo}}">
                                                        {{cc.descri}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group" style="margin-bottom: 0.5rem;">
                                                <label style="margin-right: .5rem">Tipo cuenta</label>
                                                <input class="col-md-2 form-control form-control-sm m-r-5"
                                                    id="codTipoCuentaUpd" name="codTipoCuentaUpd"
                                                    [(ngModel)]="codTipoCuentaUpd" type="text"
                                                    style="margin-right: .5rem" maxlength="2"
                                                    style="text-transform:uppercase;" tabindex="1002">

                                                <select class="form-control form-control-sm" id="cboTipoCuentaUpd"
                                                    name="codTipoCuentaUpd" [(ngModel)]="codTipoCuentaUpd"
                                                    (change)="onChangeTipoCuenta()" disabled tabindex="1003">
                                                    <option *ngFor="let ccc of tipocuentas" value="{{ccc.codigo}}">
                                                        {{ccc.descri}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="input-group" style="margin-bottom: 0.5rem;">
                                                <label style="margin-right: 1.5rem">Moneda</label>
                                                <input class="form-control form-control-sm col-md-2 m-r-5"
                                                    id="codMonedaUpd" name="codMonedaUpd" [(ngModel)]="codMonedaUpd"
                                                    type="text" tabindex="1004" maxlength="3">
                                                <select class="form-control form-control-sm" id="cboMoneda"
                                                    name="codMonedaUpd" tabindex="1005" [(ngModel)]="codMonedaUpd"
                                                    disabled>
                                                    <option *ngFor="let mon of monedas" value="{{mon.codmon}}">
                                                        {{mon.desmon}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="input-group" style="margin-bottom: 0.5rem;">
                                                <label style="margin-right: 1.35rem">N° cuenta</label>
                                                <input class="form-control form-control-sm" id="desCuentaUpd"
                                                    name="desCuentaUpd" tabindex="1006" [(ngModel)]="desCuentaUpd"
                                                    type="text" style="margin-right: .5rem" maxlength="100"
                                                    style="text-transform:uppercase;">
                                            </div>
                                        </div>
                                    </div>

                                </form>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-rounded btn-success m-b-15"
                                    (click)="modificarBanco();" tabindex="5">
                                    <i class=" fas fa-angle-double-right"></i> Continuar</button>
                                <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                                    (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                                    Cancelar</button>

                            </div>
                        </ng-template>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>